<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <!-- Modal Dialog starts here -->
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    (click)="close()"
                    alt="Close"
                    title="Close"
                    aria-hidden="true">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <h3 class="modal-title">{{title}}</h3>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        <div class="col-xs-1">
                            <i class="nlrp-icon nlrp-icon-warning nlrp-36 alertImageFormat"></i>
                        </div>

                        <div class="col-xs-11">
                            <p class="alertMessageFormat">
                                {{message}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <span class="inline-buttons">
                    <button
                        type="button"
                        id="chosenVersionBtn"
                        class="btn btn-default nlr-btn-sm"
                        (click)="loadChosenVerion()"
                        title="Load chosen version">
                        Chosen version
                    </button>
                </span>
                <span class="inline-buttons">
                    <button
                        type="button"
                        id="latestVersionBtn"
                        class="btn btn-default nlr-btn-sm"
                        (click)="loadLatestVersion()"
                        title="Load latest version">
                        Latest version
                    </button>
                </span>
                <span class="inline-buttons"
                    ><p>
                        <button
                            type="button"
                            id="cancelFormerTenuresBtn"
                            class="btn btn-warning nlr-btn-sm"
                            (click)="close()"
                            ng-click="amendReplaceLatestModalController.cancel()"
                            title="Cancel"
                            >Cancel</button
                        >
                    </p></span
                >
            </div>
        </div>
    </div>
</div>
